import { getFrom } from "lib/redirects"

export default function isPrivate(router) {
	return getFrom(router.route).includes("profile")
		&& !router.route.includes("renew")
}
